export default __webpack_public_path__ + "static/media/icon_arrow_back.14c6c274.svg";